import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";
import { useRef } from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { SwiperNavButton } from "@/components/Product/ImageViewer/partials/SwiperNavButton/swiperNavButton.component";
import { MappedContextProvider } from "@/context/mapped.context";
import { useImpressionTracking } from "@/utils/hooks/tracking/useImpressionTracking.hook";

import { useBannerSliderContext } from "../context/bannerSlider.context";
import { useProgressBarContext } from "./progressBar/context/progressBar.context";

const Slider = ({ children }: RequireChildrenFor<{}>) => {
    const { speed, slides, setMainSwiper, trackingProps, setActiveIndex } =
        useBannerSliderContext();
    const { ref } = useImpressionTracking(trackingProps);
    const { stopTimer } = useProgressBarContext();
    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    return (
        <div
            className={cn("tw:flex tw:w-full tw:relative")}
            ref={ref}
        >
            <SwiperNavButton
                innerRef={navigationPrevRef}
                className={cn(
                    "tw:hidden tw:md:block tw:absolute tw:left-0 tw:top-1/2",
                    "tw:bg-background tw:translate-y-[-50%] tw:layer-base/[2]",
                    "tw:px-1 tw:opacity-100!"
                )}
                disabled={false}
                icon="left"
                onClick={() => {
                    stopTimer();
                }}
            />

            <Swiper
                modules={[Navigation]}
                onSwiper={setMainSwiper}
                updateOnWindowResize={true}
                onRealIndexChange={(swiper) => {
                    setActiveIndex(swiper.realIndex);
                }}
                onSliderMove={stopTimer}
                resizeObserver={true}
                slidesPerView={1}
                slidesPerGroup={1}
                rewind={true}
                wrapperClass={cn("tw:w-screen tw:max-w-full")}
                navigation={{
                    nextEl: navigationNextRef.current,
                    prevEl: navigationPrevRef.current
                }}
                loop={true}
                speed={speed}
            >
                {slides.map((_, index) => (
                    <SwiperSlide
                        key={index}
                        className={cn("tw:flex tw:h-auto")}
                    >
                        <MappedContextProvider index={index}>
                            {children}
                        </MappedContextProvider>
                    </SwiperSlide>
                ))}
            </Swiper>
            <SwiperNavButton
                innerRef={navigationNextRef}
                className={cn(
                    "tw:hidden tw:md:block tw:absolute tw:right-0 tw:top-1/2",
                    "tw:bg-background tw:translate-y-[-50%] tw:layer-base/[2]",
                    "tw:px-1 tw:opacity-100!"
                )}
                disabled={false}
                icon="right"
                onClick={() => {
                    stopTimer();
                }}
            />
        </div>
    );
};

export { Slider };
